import RecipeService from "../../service/RecipeService";

const recipeService = new RecipeService();
export default{
    namespaced: true,
    state() {
        return {
            recipe: null,
            filtersRecipesTable: null,
            categories: null
        }
    },
    getters: {
        getRecipe: (state) => {
            return state.recipe;
        },
        getRecipeList: (state) => {
            return state.recipeList.items;
        },
        getRecipeListCategory: (state) => {
            return state.recipeList.category;
        },
        getFiltersRecipesTable: (state) => {
            return state.filtersRecipesTable;
        },
        getCategories: (state) => {
            return state.categories;
        },
    },
    mutations: {
        setRecipe: (state, payload) => {
            state.recipe = payload;
        },
        setRecipeListCategory: (state, payload) => {
            state.recipeList.category = payload;
        },
        setRecipeListForPage: (state, payload) => {
            state.recipeList.items[payload.page] = payload.values;
        },
        setFiltersRecipesTable: (state, payload) => {
            state.filtersRecipesTable = payload;
        },
        setCategories: (state, payload) => {
            state.categories = payload;
        },
    },
    actions: {
        async getSingleRecipe(context,payload) {
            let response = await recipeService.getSingleRecipe(payload.access_token, payload.id, payload.populate=undefined);
            context.commit("setRecipe", response);
            return response;
        },
        async getRecipeList(context, payload) {
            let response = await recipeService.getRecipes(payload.access_token, payload.params);
            context.commit("setRecipeListForPage", { values: response, page: payload.params["pagination[page]"]-1});
            context.commit("setRecipeListCategory", payload.params["filters[category][key][$eq]"]);
            return response;
        },
        async getCategories(context, payload) {
            let response = await recipeService.getCategories(payload.access_token, payload.params);
            context.commit("setCategories", response);
            return response;
        },
        async getCategoryTranslation(context, payload) {
            let response = await recipeService.getCategoryTranslation(payload.access_token, payload.params);
            context.commit("setRecipeListCategory", response);
            return response;
        },
    }
};